/* Two big cards. Desktop: hovering fires one glitch flash (plus a title scramble). Touch: a tap plays the flash,
   then the card opens. Reduced motion skips the flash entirely. */
(function () {
  'use strict';
  var ST = window.ST || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&/';
  var FLASH = 520;

  function scramble(el) {
    if (!el) return;
    var final = el.dataset.text || (el.dataset.text = el.textContent);
    var frame = 0, total = final.length * 2 + 8;
    cancelAnimationFrame(el._raf);
    (function tick() {
      var out = '';
      for (var i = 0; i < final.length; i++) {
        if (final[i] === ' ') { out += ' '; continue; }
        out += frame > i * 2 + 5 ? final[i] : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
      }
      el.textContent = out;
      if (frame++ < total) el._raf = requestAnimationFrame(tick); else el.textContent = final;
    })();
  }

  function flash(card) {
    if (reduceMotion || ST.glitch === false) return false;
    card.classList.remove('is-glitch');
    void card.offsetWidth;
    card.classList.add('is-glitch');
    scramble(card.querySelector('[data-scramble]'));
    clearTimeout(card._t);
    card._t = setTimeout(function () { card.classList.remove('is-glitch'); }, FLASH + 40);
    return true;
  }

  function wire(card) {
    if (card.dataset.ready) return;
    card.dataset.ready = '1';
    if (canHover) {
      card.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen') flash(card); });
      return;
    }
    /* Touch: flash first, then open. Respect new-tab gestures and already-animating taps. */
    card.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (card.dataset.leaving) return;
      var did = flash(card);
      if (!did) return;
      e.preventDefault();
      card.dataset.leaving = '1';
      setTimeout(function () { window.location.href = card.href; }, FLASH - 60);
    });
  }

  function scan() { document.querySelectorAll('[data-glitch-card]').forEach(wire); }
  scan();
  document.addEventListener('shopify:section:load', scan);
  /* In the theme editor, selecting a card block previews the flash. */
  document.addEventListener('shopify:block:select', function (e) { var c = e.target && e.target.closest ? e.target.closest('[data-glitch-card]') : null; if (c) flash(c); });
})();
